import React,{useState} from 'react'
import authQueries from '../../../queries/authQueries'
import { Link, useNavigate } from "react-router-dom";
import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = yup.object({

    name: yup
      .string('⚠ Enter District Name')
      .required('⚠ District Name is required')
      .min(2,'⚠ District Name must be more than 2 characters '),
    order: yup
      .string('⚠ Enter Display Order')
      .required('⚠ Display Order is required'),
  });

const  AddDistrict = () => {

    const [errName, setErrName] = useState('')

    const navigate = useNavigate();

    const { register, handleSubmit, formState:{ errors } } = useForm({

        resolver: yupResolver(validationSchema)
    
    });

    const AddDistrictdata = 

    authQueries.useDistrictMutationAdd(

        (response) => {

            if(response?.message === "Success"){
                navigate('/district')
            }else if(response?.error[0].name){
                setErrName("⚠ "+response?.error[0].name)
            }
        }
    );

    const onSubmit = (data) => {

    
        const datavalues = {
            name: data.name,
            display_order: data.order,
            status: "ACTIVE",
    
        };
    
        AddDistrictdata.mutateAsync(datavalues);    
    
      }


  return (

    <div>

        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
            <li className="breadcrumb-item"><Link to="/district">Districts</Link></li>
            <li className="breadcrumb-item active" aria-current="page">Add District</li>
            </ol>
        </nav>


        <div className="add_clients">

            <div className="card">
                <div className="card-header">
                    Add District
                </div>
                <div id="travel_history" className="collapse show" data-parent="#accordion">
                    <div className="card-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className='form-group'>
                                        <div id='parent' className='form-group'>
                                            <label htmlFor="">District Name</label>
                                            <input className="form-control"  {...register("name")} type="text" name='name' />
                                            <div className='error-msg'>{errors.name?.message} {errName}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className='form-group'>
                                        <div id='parent' className='form-group'>
                                            <label htmlFor="">Display Order</label>
                                            <input className="form-control"  {...register("order")} type="text" name='order' />
                                            <div className='error-msg'>{errors.order?.message}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <button type='submit' className="btn btn-default btn-save">Submit</button>
                                </div>
                            </div>

                        </form>                            
                    </div>
                </div>
            </div>

        </div>


    </div>

  )
}

export default AddDistrict